<template>
    <form autocomplete="off" @submit.prevent="handleLogin()">
        <div v-if="loginError" class="form-msg error">
            <p>Your username and/or password is incorrect</p>
        </div>
        <div class="form-row">
            <span class="field-wrapper email">
                <label class="top-level" for="user-email">E-mail</label>
                <div class="input-wrapper">
                    <input type="email" id="user-email" name="username" placeholder="E-mail" @keyup="changeInput()"
                        v-model="user.username" :class="{ error: loginError }" autocomplete="off" />
                </div>
            </span>
        </div>

        <div class="form-row">
            <span class="field-wrapper password">
                <label class="top-level" for="user-password">Password</label>
                <div class="input-wrapper">
                    <input type="password" id="user-password" name="password" placeholder="Password"
                        @keyup="changeInput()" v-model="user.password" :class="{ error: loginError }"
                        autocomplete="off" />
                </div>
            </span>
        </div>

        <button class="submit">Login</button>
    </form>
</template>

<script>
//Vue
import { defineComponent, ref } from 'vue';

import { useGlobalStore } from '@/stores/global';

export default defineComponent({
    setup() {
        const globalStore = useGlobalStore();

        const user = ref({
            username: '',
            password: ''
        });
        const loginError = ref(false);

        function changeInput() {
            loginError.value = false;
        }

        function handleLogin() {
            if (
                user.value.username == 'developer@streampac.io' &&
                user.value.password == '67[3bb=Udh82'
            ) {
                globalStore.removeUnderConstruction();
                loginError.value = false;

                //24h validated
                setCookie('under-construction-validated', 'yes', 1);
            } else {
                loginError.value = true;
                user.value.username = '';
                user.value.password = '';
            }
        }

        function setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            let expires = 'expires=' + d.toUTCString();
            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
        }

        return {
            user,
            loginError,
            //functions
            changeInput,
            handleLogin
        }
    }
});
</script>
